import { TicketRepository } from '../repositories/TicketRepository'

export function ListAgentsAndResponsiblesByAreaCase(
  ticketRepository: TicketRepository
) {
  return async function ({ areaId }: { areaId: string }) {
    return await ticketRepository.listAgentsAndResponsiblesByArea({ areaId })
  }
}
